import { render, staticRenderFns } from "./ModuleTerms.vue?vue&type=template&id=17302b9e"
import script from "./ModuleTerms.vue?vue&type=script&lang=js"
export * from "./ModuleTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports